import React, { ReactElement, PropsWithChildren } from "react";
import useSideLinksStyles, { SideLinksClasses } from "./styles";

export type LinksData = {
  title: string;
  link?: string;
};

export type SideLinksProps = {
  links: Array<LinksData>;
};

function SideLinks({
  links = [],
}: PropsWithChildren<SideLinksProps>): ReactElement {
  const useStyles: SideLinksClasses = useSideLinksStyles();

  const SideLinksGenerator = links.map((data, i) => {
    return (
      <li key={i} className={useStyles.item}>
        <a href={data.link} className={useStyles.linksItem}>
          {data.title}
        </a>
      </li>
    );
  });

  return <ul className={useStyles.linksList}>{SideLinksGenerator}</ul>;
}
export default SideLinks;
